import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BankAccountsComponent } from './bank-accounts.component';
import { AddBankAccountComponent } from './add-bank-account/add-bank-account.component';
import { UpdateBankAccountComponent } from './update-bank-account/update-bank-account.component';

const routes: Routes = [{ path: '', component: BankAccountsComponent },
{path: 'add-bank-account', component: AddBankAccountComponent},
{path: 'update-bank-account/:id', component: UpdateBankAccountComponent} ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BankAccountsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/client/my-settings/bank-accounts/bank-accounts-routing.module.ts